/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_Li4Inputs */

const en_guide_json_rest_api_s5_li4 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return consistent error responses with meaningful error codes and messages`)
};

const ko_guide_json_rest_api_s5_li4 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의미 있는 오류 코드와 메시지가 포함된 일관된 에러 응답을 반환하세요`)
};

const ja_guide_json_rest_api_s5_li4 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意味のあるエラーコードとメッセージを含む一貫したエラーレスポンスを返してください`)
};

/**
* | output |
* | --- |
* | "Return consistent error responses with meaningful error codes and messages" |
*
* @param {Guide_Json_Rest_Api_S5_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_li4 = /** @type {((inputs?: Guide_Json_Rest_Api_S5_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_li4(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_li4(inputs)
	return ja_guide_json_rest_api_s5_li4(inputs)
});